import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import { useState } from "react";
import SubscriptionList from "../../features/manageSubscriptions/subscriptionList";
import AddIcon from '@mui/icons-material/Add';
import { Button } from "@mui/material";

const ManageSubscriptions = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <>
      <div className="main_title">
        <h1>Subscription Plans Management</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Subscription Plans Management
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
          </div>
          <div className="right_s">
            <Button className="btn btn_primary" onClick={() => navigate("/manage-subscriptions/add")}><AddIcon /> Add Subscription</Button>
          </div>
        </div>

        <SubscriptionList />

      </div>
    </>
  );
};

export default ManageSubscriptions;
